var _path, _path2, _path3, _path4, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagEnglishinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.667 1H2.333A1.333 1.333 0 001 2.333v21.334A1.333 1.333 0 002.333 25h29.334A1.334 1.334 0 0033 23.667V2.333A1.334 1.334 0 0031.667 1z",
    fill: "#002781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 2.333A1.334 1.334 0 0031.667 1h-3.441l-8.56 6.584V1h-5.333v6.584L5.774 1h-3.44A1.333 1.333 0 001 2.333v1.724l8.16 6.276H1v5.334h8.16L1 21.943v1.724A1.333 1.333 0 002.333 25h3.441l8.56-6.584V25h5.333v-6.584L28.226 25h3.44A1.334 1.334 0 0033 23.667v-1.724l-8.16-6.276H33v-5.334h-8.16L33 4.057V2.333z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 11.667H18.333V1h-2.666v10.667H1v2.666h14.667V25h2.666V14.333H33v-2.666z",
    fill: "#D10D24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 15.482L2.055 24.97c.091.02.185.03.278.03h1.591l10.41-8.043v-1.475zM19.666 10.518l12.28-9.488a1.372 1.372 0 00-.28-.03h-1.59l-10.41 8.044v1.474zM13.004 10.333L1.41 1.375a1.326 1.326 0 00-.41.958v.2l10.096 7.8h1.908zM20.996 15.666l11.594 8.96a1.326 1.326 0 00.41-.96v-.2l-10.096-7.8h-1.908z",
    fill: "#D10D24"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 2.5,
    stroke: "#8F8FA3"
  })));
}

export default SvgFlagEnglishinline;